"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgBullhorn(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M19.908 2.66l.007.107-.001 4.384a.765.765 0 01.255-.043A3.831 3.831 0 0124 10.938a3.831 3.831 0 01-3.83 3.83.765.765 0 01-.256-.045v4.385c0 .55-.558.91-1.048.712l-.097-.047-6.973-3.985H5.617v5.362a.766.766 0 01-1.525.104l-.007-.104v-5.362H1.787a1.79 1.79 0 01-1.781-1.64L0 14V7.873a1.79 1.79 0 011.641-1.78l.146-.007h10.009l6.973-3.984a.766.766 0 011.139.557zm-1.525 1.427l-6.003 3.43a.762.762 0 01-.447.098l-.069.003H5.617v6.638H12l.035.001c.018 0 .036.002.055.005l-.09-.006a.77.77 0 01.298.06l.082.041 6.003 3.43v-13.7zM4.085 7.618H1.787a.26.26 0 00-.248.198l-.007.057v6.128a.26.26 0 00.197.249l.058.006h2.298V7.618zm15.829.978v4.683c.048-.017.099-.03.151-.037l.104-.007a2.3 2.3 0 002.3-2.298 2.3 2.3 0 00-2.3-2.298.765.765 0 01-.255-.043z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgBullhorn;
exports.default = _default;